import React, { Fragment, useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import { H4 } from "../../../../AbstractElements";
import {
  Button,
  Col,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Form,
  FormGroup,
  Input,
  Label,
  Media,
  Row,
  UncontrolledDropdown,
  Badge,
  Nav, NavItem, NavLink
} from "reactstrap";
import { Eye, MoreVertical, Truck, AlertCircle } from "react-feather";
import CommonModal from "../../../UiKits/Modals/common/modal";
import axios from "axios";
import moment from "moment";
import Swal from "sweetalert2";
import { baseURL, getPublicS3Url } from "../../../../Services/api/baseURL";
import Loader from "../../../Loader/Loader";
import DatePicker from 'react-datepicker';
import { useNavigate } from "react-router";
import { format } from 'date-fns';
import 'react-datepicker/dist/react-datepicker.css';


const OrderTable = () => {
  const token = JSON.parse(localStorage.getItem("token"));
  const [orderData, setOrderData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    page: 1,
    perPage: 10,
    totalRows: 0,
  });

  const [showDeliveryModal, setShowDeliveryModal] = useState(false);
  console.log(showDeliveryModal, "showDeliveryModal");
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [showPaymentStatusModal, setShowPaymentStatusModal] = useState(false);
  const [selectedSubOrder, setSelectedSubOrder] = useState(null);
  const [activeTab, setActiveTab] = useState('Pending');
  const [activeTabs, setActiveTabs] = useState('day');
  const [startDate, setStartDate] = useState(new Date());
  const [formattedStartDate, setFormattedStartDate] = useState(format(new Date(), 'MMM yyyy'));
  console.log(startDate, "startDate")
  const [selectedDeliveryPerson, setSelectedDeliveryPerson] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectedPaymentStatus, setSelectedPaymentStatus] = useState("");
  const [cancelReason, setCancelReason] = useState("");
  const [deliveryPersons, setDeliveryPersons] = useState([]);
  const navigate = useNavigate();

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };
  const handleTabClicks = (tab) => {
    setActiveTabs(tab);
  };


  const fetchOrders = async () => {
    console.log(formattedStartDate, "formattedDate")
    setLoading(true);
    try {
      const response = await axios.get(`${baseURL}/api/order/admin`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          month: String(formattedStartDate),
          period: String(activeTabs),
          status: String(activeTab)
        }
      });
      console.log(response.data, "response of orders")

      if (Array.isArray(response?.data?.orders)) {
        setOrderData(response?.data?.orders?.reverse());
        setPagination(prev => ({ ...prev, totalRows: response?.data?.orders?.length || 0 }));
      } else {
        throw new Error("Unexpected response format");
      }
    } catch (error) {
      console.error('Error fetching orders:', error);
      // Swal.fire({
      //   title: "Error",
      //   text: "Failed to fetch orders",
      //   icon: "error",
      //   confirmButtonColor: "#fc2c54",
      // });
    } finally {
      setLoading(false);
    }
  };



  // const fetchDeliveryPersons = async () => {
  //   try {
  //     const response = await axios.get(
  //       `${baseURL}/api/users/delivery-persons`,
  //       {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //         },
  //       }
  //     );
  //     console.log(response);
  //     setDeliveryPersons(response.data.deliveryPersons);
  //   } catch (error) {
  //     console.error("Error fetching delivery persons:", error);
  //   }
  // };

  // useEffect(() => {

  //   fetchDeliveryPersons();
  // }, []);

  useEffect(() => {
    fetchOrders();

  }, [activeTab, activeTabs, formattedStartDate]);

  const getBadgeColor = (status, type) => {
    console.log(status, type)
    if (type === "payment") {
      return (
        {
          pending: "danger",
          failed: "danger",
          completed: "success",
          success: "success",
        }[status] || "secondary"
      );
    }
    if (type === "order") {
      return (
        {
          Pending: "warning",
          Confirmed: "info",
          Delivered: "success",
          Cancelled: "danger",
        }[status] || "secondary"
      );
    }
    if (type === "delivery") {
      return (
        {
          pending: "primary",
          in_transit: "primary",
          delivered: "success",
          accepted: "success",
          cancelled: "primary",
          failed: "danger",
        }[status] || "secondary"
      );
    }
    if (type === "placed") {
      return (
        {
          placed: "warning",
          cancelled: "primary",
          delivered: "success",
          failed: "danger",
        }[status] || "secondary"
      );
    }
    return "secondary";
  };

  const handleStatusUpdate = async () => {
    if (!selectedSubOrder || !selectedStatus) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Please select a status'
      });
      return;
    }

    try {
      const payload = {
        status: selectedStatus,
        ...(selectedStatus === 'cancelled' && { cancelReason })
      };

      const response = await axios.patch(
        `${baseURL}/api/order/${selectedSubOrder._id}`,
        payload,
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      Swal.fire({
        icon: 'success',
        title: 'Status Updated',
        text: 'Order status has been updated successfully',
        showConfirmButton: false,
        timer: 1500
      });

      setShowStatusModal(false);
      setSelectedStatus("");
      setCancelReason("");
      fetchOrders();
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.response?.data?.message || 'Failed to update order status'
      });
    }
  };

  const handlePaymentStatusUpdate = async () => {
    if (!selectedSubOrder || !selectedPaymentStatus) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Please select a payment status'
      });
      return;
    }

    try {
      const payload = {
        paymentStatus: selectedPaymentStatus
      };

      const response = await axios.patch(
        `${baseURL}/api/order/${selectedSubOrder._id}/payment`,
        payload,
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      Swal.fire({
        icon: 'success',
        title: 'Payment Status Updated',
        text: 'Payment status has been updated successfully',
        showConfirmButton: false,
        timer: 1500
      });

      setShowPaymentStatusModal(false);
      setSelectedPaymentStatus("");
      fetchOrders();
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.response?.data?.message || 'Failed to update payment status'
      });
    }
  };


  const columns = [
    {
      name: "Order ID",
      selector: (row) => row.orderId||row._id,
      sortable: true,
      width: "210px",
      left: true,
    },
    {
      name: "Customer",
      selector: (row) => row.user?.name,
      width: "120px",
      sortable: true,
      left: true,
      cell: (row) => (
        <div>
          <div>{row.user?.name || "N/A"}</div>
          <small className="text-muted">{row.user?.phone || "N/A"}</small>
        </div>
      ),
    },
    {
      name: "Address",
      cell: (row) => row?.address?.address,
      wrap: true,
      width: "250px",
      left: true
    },
    {
      name: "Grand Total",
      selector: (row) => row.grandTotal,
      width: "130px",
      sortable: true,
      left: true,
      cell: (row) => (
        <span className="fw-bold">
          ₹
          {row.grandTotal?.toLocaleString("en-IN", {
            maximumFractionDigits: 2,
          })}
        </span>
      ),
    },
    {
      name: "Delivery charges",
      selector: (row) => row.deliveryCharge,
      sortable: true,
      width: "170px",
      left: true,
      cell: (row) => (
        <span className="fw-bold">
          ₹
          {row.deliveryCharge?.toLocaleString("en-IN", {
            maximumFractionDigits: 2,
          })}
        </span>
      ),
    },


    {
      name: "Payment Status",
      selector: (row) => row.transaction?.status,
      sortable: true,
      width: "150px",
      left: true,
      cell: (row) => (
        <Badge color={getBadgeColor(row.transaction?.status, "payment")}>
          {row.transaction?.status?.toUpperCase()}
        </Badge>
      ),
    },
    {
      name: "Order Status",
      selector: (row) => row.status,
      sortable: true,
      width: "140px",
      left: true,
      cell: (row) => (
        <Badge color={getBadgeColor(row.status, "order")}>
          {row.status?.toUpperCase()}
        </Badge>
      ),
    },
    // {
    //   name: "Delivery charges",
    //   selector: row => row.deliveryCharge,
    //   sortable: true,
    //   cell: row => (
    //     <span className="fw-bold">₹{row.deliveryCharge?.toLocaleString('en-IN', { maximumFractionDigits: 2 })}</span>
    //   )
    // },
    // {
    //   name: "Total Tax",
    //   selector: row => row.taxDetails.totalTax,
    //   sortable: true,
    //   cell: row => (
    //     <span className="fw-bold">₹{row.taxDetails?.totalTax?.toLocaleString('en-IN', { maximumFractionDigits: 2 })}</span>
    //   )
    // },
    {
      name: "Coupon",
      selector: (row) => row.coupon,
      width: "120px",
      sortable: true,
      left: true,
      cell: (row) =>
        row.coupon?.code ? (
          <div className="d-flex flex-column gap-2">
            <Badge color="info" pill>
              {row.coupon?.code}
            </Badge>
            ₹{row.totals?.discount}
          </div>
        ) : (
          "No Coupon"
        ),
    },
    {
      name: "Order Date",
      selector: (row) => row.createdAt,
      width: "150px",
      sortable: true,
      left: true,
      cell: (row) => moment(row.createdAt).format("DD/MM/YYYY"),
    },
    {
      name: "Actions",
      left: true,
      cell: (row) => (
        <UncontrolledDropdown direction="down" className="mb-20">
          <DropdownToggle tag="span" className="p-2 cursor-pointer">
            <MoreVertical size={16} />
          </DropdownToggle>
          <DropdownMenu container="body" end>
            <DropdownItem
              onClick={() => navigate(`/orders/SubOrder/${row._id}`)}
              style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', padding: "10px" }}
            >
              <Eye className="me-2" size={14} />
              View Details
            </DropdownItem>
            {/* <DropdownItem
              onClick={() => {
                setSelectedSubOrder(row);
                setShowDeliveryModal(true);
              }}
              style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', padding: "10px" }}
            >
              <Truck className="me-2" size={14} />
              Assign Delivery
            </DropdownItem> */}
            {/*  <DropdownItem
              onClick={() => {
                setSelectedSubOrder(row);
                AssignPorter(row)
              }}
              style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', padding: "10px" }}
            >
              <Truck className="me-2" size={14} />
              Assign Porter
            </DropdownItem> */}
            {/* <DropdownItem
              onClick={() => {
                setSelectedSubOrder(row);
                ConfirmOrder(row);
              }}
              style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', padding: "10px" }}
            >
              <AlertCircle className="me-2" size={14} />
              Confirm Order
            </DropdownItem> */}
            <DropdownItem
              onClick={() => {
                setSelectedSubOrder(row);
                setSelectedStatus(row.orderStatus);
                setShowStatusModal(true);
              }}
              style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
            >
              <AlertCircle className="me-2" size={14} />
              Update Order Status
            </DropdownItem>
            <DropdownItem
              onClick={() => {
                setSelectedSubOrder(row);
                setSelectedPaymentStatus(row.transaction?.status || "");
                setShowPaymentStatusModal(true);
              }}
              style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
            >
              <AlertCircle className="me-2" size={14} />
              Update Payment Status
            </DropdownItem>
          </DropdownMenu>
        </UncontrolledDropdown>
      ),
    },
  ];

  const productColumns = [
    {
      name: 'Image',
      selector: row => row?.product?.images,
      center: true,
      cell: row => {
        console.log(row)
        const firstImage = Array.isArray(row?.product?.images) ? row?.product?.images?.[0] : row?.product?.images;
        return firstImage ? (
          <img
            src={getPublicS3Url(firstImage)}
            alt={row?.product?.name}
            style={{
              width: '60px',
              height: '60px',
              objectFit: 'cover',
              borderRadius: '6px',
              cursor: 'pointer',
            }}
            onClick={() => navigate(`/products/${row?._id}`)}
          />
        ) : (
          <span
            style={{ cursor: 'pointer', color: '#007bff' }}
            onClick={() => navigate(`/products/${row?._id}`)}
          >
            No Image
          </span>
        );
      }
    },
    {
      name: 'Product Name',
      selector: row => row?.product?.name,
      sortable: true,
      cell: row => (
        <span
          style={{ cursor: 'pointer', color: '#007bff' }}
          onClick={() => navigate(`/products/${row?._id}`)}
        >
          {row?.product?.name}
        </span>
      ),
    },
    {
      name: 'Category',
      selector: row => row?.product?.category?.name || 'N/A',
      sortable: true,
    },
    {
      name: 'Price (₹)',
      selector: row =>
        row?.product?.sellingType === 'unit'
          ? row?.product?.unitDetails?.price
          : row?.product?.weightDetails?.pricePerKg,
      sortable: true,
      center: true,
    },
    {
      name: 'OrinalPrice (₹)',
      selector: row =>
        row?.product?.sellingType === 'unit'
          ? row?.product?.unitDetails?.originalPrice
          : row?.product?.weightDetails?.originalPricePerKg,
      sortable: true,
      center: true,
    },
    {
      name: 'Stock',
      selector: row => {
        if (row?.product?.sellingType === 'unit') return row?.product?.unitDetails?.stock || 0;
        if (row?.product?.sellingType === 'weight' && row?.product?.weightDetails?.options?.length) {
          return row?.product?.weightDetails?.options?.reduce(
            (sum, option) => sum + (option?.stock || 0),
            0
          );
        }
        return 0;
      },
      sortable: true,
      center: true,
    },
    {
      name: 'Best Seller',
      sortable: false,
      wrap: true,
      cell: row => (
        <div className="line-clamp-2 max-w-xs text-sm text-gray-700">
          {row?.product?.isBestSeller ? "Yes" : "No"}
        </div>
      )
    },
    {
      name: 'Created Date',
      selector: row => moment(row?.product?.createdAt).format('DD/MM/YYYY'),
      sortable: true,
      center: true,
    },

  ];
  const filteredOrders = orderData.filter(
    (item) =>
      item._id?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.user?.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.user?.mobile?.includes(searchTerm) ||
      item.couponCode?.toLowerCase().includes(searchTerm.toLowerCase())
  );


  const handleDateChange = (date) => {
    if (!date) return;
    const formatted = format(date, 'MMM yyyy'); // e.g., "Jun 2025"
    console.log(formatted, "formatted date");
    setStartDate(date);
    setFormattedStartDate(formatted);
  };
  const ExpandedComponent = ({ data }) => {
    console.log(data.items)
    return (<div className="p-4 bg-light">
      <h6 className="mb-3 text-gray-900 fw-bold">Products</h6>
      <DataTable
        data={data.items}
        columns={productColumns}
        dense
        className="bg-white rounded shadow-sm"
      />
    </div>
    )
  };

  console.log(filteredOrders, "filteredorders");

  return (
    <Fragment>
      <div className="card-header d-flex align-items-center justify-between" style={{ padding: '15px 30px' }}>
        <h4>Orders</h4>

        {/* <div className="file-content">
          <Media>
            <div className="mb-0 form-group position-relative search_outer d-flex align-items-center">
              <i className="fa fa-search"></i>
              <input
                className="form-control border-0"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                type="text"
                placeholder="Search by ID, Customer, Mobile or Coupon..."
              />
            </div>

          </Media>
        </div> */}


        <div style={{ display: "flex", flexDirection: "row", gap: "12px" }}>


          <Nav tabs className='product_variant_tabs'>
            <NavItem>
              <NavLink className={activeTab === 'Pending' ? 'active' : ''} onClick={() => handleTabClick('Pending')}>
                Pending
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink className={activeTab === 'Confirmed' ? 'active' : ''} onClick={() => handleTabClick('Confirmed')}>
                Confirmed
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink className={activeTab === 'Delivered' ? 'active' : ''} onClick={() => handleTabClick('Delivered')}>
                Delivered
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink className={activeTab === 'Cancelled' ? 'active' : ''} onClick={() => handleTabClick('Cancelled')}>
                Cancelled
              </NavLink>
            </NavItem>

          </Nav>
          <div>
            <DatePicker
              className="form-control datepickerr digits mx-2"
              selected={startDate}
              onChange={(date) => {
                if (!date) {
                  setStartDate(null);
                  return;
                }
                handleDateChange(date);
              }}
              showMonthYearPicker
              dateFormat="MMM yyyy"
              yearItemNumber={9}
              showIcon
              placeholderText="Select month"
              // maxDate={new Date()} // 🔒 Disable future months
            />




          </div>
        </div>
      </div>


      <DataTable
        columns={columns}
        data={filteredOrders}
        pagination
        paginationPerPage={pagination.perPage}
        paginationRowsPerPageOptions={[10, 25, 50]}
        onChangePage={(page) => setPagination(prev => ({ ...prev, page }))}
        onChangeRowsPerPage={(newPerPage) => setPagination(prev => ({ ...prev, perPage: newPerPage, page: 1 }))}
        progressPending={loading}
        progressComponent={<Loader />}
        expandableRows
        expandableRowsComponent={ExpandedComponent}
      />

      {/* Delivery Assignment Modal */}
      <CommonModal
        isOpen={showDeliveryModal}
        title="Assign Delivery Person"
        toggler={() => setShowDeliveryModal(false)}
        size="md"
      >
        <Container>
          <Form>
            <Col xxl={12}>
              <FormGroup>
                <Label>Select Delivery Person</Label>
                <Input
                  type="select"
                  value={selectedDeliveryPerson}
                  onChange={(e) => setSelectedDeliveryPerson(e.target.value)}
                >
                  <option value="">Select...</option>
                  {deliveryPersons.map((person) => (
                    <option key={person._id} value={person._id}>
                      {person.name}
                    </option>
                  ))}
                </Input>
              </FormGroup>
              <Row className="text-center">
                <Button
                  color="primary"
                  // onClick={handleDeliveryAssign}
                  disabled={!selectedDeliveryPerson}
                >
                  Assign Delivery
                </Button>
              </Row>
            </Col>
          </Form>
        </Container>
      </CommonModal>

      {/* Status Update Modal */}
      <CommonModal
        isOpen={showStatusModal}
        title="Update Order Status"
        toggler={() => setShowStatusModal(false)}
        size="md"
      >
        <Container>
          <Form>
            <Col xxl={12}>
              <FormGroup>
                <Label>Select Status</Label>
                <Input
                  type="select"
                  value={selectedStatus}
                  onChange={(e) => setSelectedStatus(e.target.value)}
                >
                  <option value="">Select...</option>
                  {selectedSubOrder?.status?.toLowerCase() === 'pending' && (
                    <>
                      <option value="confirmed">Confirmed</option>
                      <option value="delivered">Delivered</option>
                      <option value="cancelled">Cancelled</option>
                    </>
                  )}
                  {selectedSubOrder?.status?.toLowerCase() === 'confirmed' && (
                    <>
                      <option value="delivered">Delivered</option>
                      <option value="cancelled">Cancelled</option>
                    </>
                  )}
                  {selectedSubOrder?.status?.toLowerCase() === 'delivered' && (
                    <>
                      <option value="cancelled">Cancelled</option>
                    </>
                  )}
                  {selectedSubOrder?.status?.toLowerCase() === 'cancelled' && (
                    <option value="pending">Pending</option>
                  )}
                </Input>
              </FormGroup>
              {selectedStatus === "cancelled" && (
                <FormGroup>
                  <Label>Cancellation Reason</Label>
                  <Input
                    type="text"
                    placeholder="Enter cancellation reason"
                    value={cancelReason}
                    onChange={(e) => setCancelReason(e.target.value)}
                  />
                </FormGroup>
              )}
              <Row className="text-center">
                <Button
                  color="primary"
                  onClick={handleStatusUpdate}
                  disabled={!selectedStatus}
                >
                  Update Status
                </Button>
              </Row>
            </Col>
          </Form>
        </Container>
      </CommonModal>

      {/* Payment Status Update Modal */}
      <CommonModal
        isOpen={showPaymentStatusModal}
        title="Update Payment Status"
        toggler={() => setShowPaymentStatusModal(false)}
        size="md"
      >
        <Container>
          <Form>
            <Col xxl={12}>
              <FormGroup>
                <Label>Select Payment Status</Label>
                <Input
                  type="select"
                  value={selectedPaymentStatus}
                  onChange={(e) => setSelectedPaymentStatus(e.target.value)}
                >
                  <option value="">Select...</option>
                  <option value="pending">Pending</option>
                  <option value="completed">Completed</option>
                  <option value="failed">Failed</option>
                  <option value="cancelled">Cancelled</option>
                </Input>
              </FormGroup>
              <Row className="text-center">
                <Button
                  color="primary"
                  onClick={handlePaymentStatusUpdate}
                  disabled={!selectedPaymentStatus}
                >
                  Update Payment Status
                </Button>
              </Row>
            </Col>
          </Form>
        </Container>
      </CommonModal>
    </Fragment>
  );
};

export default OrderTable;
